import { noop } from 'lodash-es';

import { useDarkModeClass } from 'src/hooks/useDarkModeClass';

import { ThemeContext } from './context';

export const ThemeRegistry = ({
  children,
  forceTheme,
}: React.PropsWithChildren<{ forceTheme?: 'light' | 'dark' }>) => {
  const mode = useDarkModeClass(forceTheme);

  return (
    <ThemeContext value={{ mode, toggleTheme: noop }}>{children}</ThemeContext>
  );
};
